import { Select } from "antd";
import './style.css';
import React from 'react';

type MultiSelectInputProps = {
    options: {value: string; label: string}[];
    onChange: (value: string[]) => void;
    placeholder: string;
    className: string;
    maxTagCount: number;
}

const MultiSelectInput = ({ options, onChange, placeholder, className, maxTagCount = 1 }: MultiSelectInputProps) => {
    return (
        <Select
            mode="multiple"
            placeholder={placeholder}
            onChange={onChange}
            className={className}
            rootClassName='multi-select-input'
            maxTagCount={maxTagCount}
        >
            {options.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                    {option.label}
                </Select.Option>
            ))}
        </Select>
    )
}

export default MultiSelectInput;